<template>
  <div class=" absolute_center" style=" width: 1620px;"
    :class="{_boxBg_green_secondLevel:styleType == 'typeGreen',_boxBg_dark_secondLevel:styleType == 'typeDark' ,_boxBg_blue_secondLevel:styleType == 'typeBlue', _boxBg_strong_secondLevel: styleType == 'typeStrong'}">
    <div class="selfClose_btn" style="top:10px" @click="close"></div>
    <div class="_boxTitle">{{title}}</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox" style="overflow-y: scroll;">
      <div class="page1" v-show="detailShow">
        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
            <el-form-item class="secondLevel-label" label="环保登记编码/车辆识别代码：">
              <el-input class="secondLevel-input" v-model="params.keyword" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="排放阶段：">
              <el-select class="secondLevel-select" v-model="params.vehicleEmissions" placeholder="请选择">
                <el-option label="全部" :value="''"></el-option>
                <el-option label="国I" :value="1"></el-option>
                <el-option label="国II" :value="2"></el-option>
                <el-option label="国III" :value="3"></el-option>
                <el-option label="国IV" :value="4"></el-option>
                <el-option label="国V" :value="5"></el-option>
                <el-option label="国VI" :value="6"></el-option>
                <el-option label="新能源" :value="99"></el-option>
                <el-option v-if="electricVehicle" label="纯电" :value="199"></el-option>
                <!-- <el-option label="铁路运输" :value="101"></el-option>
              <el-option label="水路运输" :value="102"></el-option>
              <el-option label="管道或管状带式输送机" :value="103"></el-option>-->
              </el-select>
            </el-form-item>
            <el-form-item style="margin-top:-1px;vertical-align: middle;margin-bottom: 0" label=" ">
              <a class="self_btn" @click="handleCurrentChange(1)">查询</a>
              <a class="self_btn" @click="reset()">重置</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" style="height: 640px;">
          <el-table :data="dataList" style="width: 100%" @row-click="rowClick" :header-cell-class-name="'thClass'" :header-row-class-name="'headTrClass'" :cell-class-name="'tdClass'"
            :row-class-name="'trClass'" class="secondLevel_table">
            <el-table-column prop="numberPlate" v-if="newAccessType" label="环保登记编码/号牌" align="center"></el-table-column>
            <el-table-column prop="numberPlate" v-else label="环保登记编码/内部管理号牌" align="center"></el-table-column>
            <el-table-column prop="registrationDate" label="注册日期" align="center"></el-table-column>
            <el-table-column prop="vin" label="车辆识别代号(VIN)" align="center"></el-table-column>
            <el-table-column prop="engineNumber" label="发动机号码" align="center"></el-table-column>
            <el-table-column prop="vehicleEmissions" label="排放阶段" align="center">
              <template #default="scope">{{vehicleMissionsName[scope.row.vehicleEmissions]}}</template>
            </el-table-column>
            <el-table-column v-if="customerId==22 ||newAccessType" prop="fuelType" label="燃料类型" align="center"></el-table-column>
            <el-table-column prop="owener" v-if="newAccessType" label="所属单位" align="center"></el-table-column>
            <el-table-column prop="vehicleType" v-if="newAccessType" label="车辆类型" align="center"></el-table-column>
            <el-table-column label="详情" align="center">
              <template #default="scope">
                <span class="view" style="cursor:pointer;color:rgb(0, 252, 255)">查看</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <el-pagination @current-change="handleCurrentChange" :current-page="params.pageNo" :page-size="params.pageSize" layout="total,prev, pager, next, jumper" :total="page_total"></el-pagination>
          <p>跳转</p>
        </div>
      </div>
      <div class="page2" v-show="!detailShow">
        <div class="selfReturn_btn" style="top:10px" @click="returnClick"></div>
        <div class="main-title" v-if="newAccessType">
          厂内运输车辆信息
        </div>
        <div class="account">
          <door-title>
            车辆基础信息
          </door-title>
          <div class="basic-info">
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">环保登记编码/号牌：</label>
              <span>{{info&&info.numberPlate}}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">车牌号码：</label>
              <span>{{info&&info.numberPlate}}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">发动机号码：</label>
              <span>{{info&&info.engineNumber}}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">车辆识别代号(VIN)：</label>
              <span>{{info&&info.vin}}</span>
            </div>
            
            <div class="basic-item">
              <label class="item-label">车队名称：</label>
              <span>所有人</span>
            </div>
            <div class="basic-item">
              <label class="item-label">注册日期：</label>
              <span>{{registrationDate(info.registrationDate)}}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">生产日期：</label>
              <span>{{ info?.productionDate }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">排放阶段：</label>
              <span>{{vehicleMissionsName[info&&info.vehicleEmissions]}}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">燃料类型：</label>
              <span>{{info&&info.fuelType}}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">所属单位：</label>
              <span>{{info&&info.owener}}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">车辆类型：</label>
              <span>{{info&&info.vehicleType}}</span>
            </div>
            <div class="basic-item" v-if="newAccessType">
              <label class="item-label">车辆品牌型号：</label>
              <span>{{info && info.model}}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">联网状态：</label>
              <span>{{info && (info.onlineStatus == 1 ? '已联网' : info.onlineStatus == 0 ? '未联网' : '未知') }}</span>
            </div>
          </div>
         <door-title style="margin-top: 20px">车辆图片</door-title>
          <div class="picture-info">
            <div class="picture-inner" @click="picture_click(info.drivingLicense)">
              <div class="picture">
                <img v-if="info.drivingLicense" :src="info&&info.drivingLicense" />
                <img v-else src="./img/no_img.png" />
                <span>行驶证</span>
              </div>
            </div>
            <div class="picture-inner" @click="picture_click(info.onBoardList)">
              <div class="picture">
                <img v-if="info.onBoardList" :src="info&&info.onBoardList" />
                <img v-else src="./img/no_img.png" />
                <span>随车清单</span>
              </div>
            </div>
            <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.vehicleImage)">
              <div class="picture">
                <img v-if="info.vehicleImage" :src="info&&info.vehicleImage" />
                <img v-else src="./img/no_img.png" />
                <span>车辆照片</span>
              </div>
            </div>
            <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.engineImage)">
              <div class="picture">
                <img v-if="info.engineImage" :src="info&&info.engineImage" />
                <img v-else src="./img/no_img.png" />
                <span>车身铭牌</span>
              </div>
            </div>
            <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.vinVerificationImg)">
              <div class="picture">
                <img v-if="info.vinVerificationImg" :src="info&&info.vinVerificationImg" />
                <img v-else src="./img/no_img.png" />
                <span>机动车环保网查询图片</span>
              </div>
            </div>
            <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.vehicleLicenseVerificationImg)">
              <div class="picture">
                <img v-if="info.vehicleLicenseVerificationImg" :src="info&&info.vehicleLicenseVerificationImg" />
                <img v-else src="./img/no_img.png" />
                <span>重型柴油车排放阶段查询图片</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import imgBox from "./components/imgBox.vue";
import doorTitle from "modules/cleanTransportComponents/components/doorTitle/doorTitle";
export default {
  name: "accountList",
  title: "详细信息",
  props: ["globalInstance"],
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  components: {
    doorTitle
  },
  data() {
    return {
      electricVehicle: bmeConfig.electricVehicle,
      pageInfo: 'accountListInFactory.vue',
      computedName: '场内运输车辆电子台账组件',
      title: '场内运输车辆电子台账',
      newAccessType: this.$store.state.newAccessType,
      styleType: "",
      detailShow: true,
      vehicleMissionsName: {
        3: "国III",
        4: "国IV",
        5: "国V",
        6: "国VI",
        99: "新能源",
        // 101: "铁路运输",
        // 102: "水路运输",
        // 103: "管道或管状带式输送机",
      },
      params: {
        keyword: "",
        vehicleEmissions: "",
        pageNo: 1,
        pageSize: 10,
        customerId: this.$store.state.customerId,
      },
      page_total: 0,
      dataList: [],
      info: [],
      customerId: this.$store.state.customerId,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
    }),
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType;
    },
    registrationDate() {
     return function (data) {
       if(data) {
         return  data.split(' ')[0];
       } else {
         return  '';
       }
      }
    }
  },
  created() {
    this.styleType = this.globalInstance.$store.state.styleType;
  },
  mounted() {
    if(this.newAccessType) {
      this.title = '厂内运输车辆电子台账';
    }
    if (this.electricVehicle) {
      this.vehicleMissionsName['199'] = '纯电';
    }
    this.getCarListInFactory();
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  methods: {
    async getCarListInFactory() {
      let url = this.globalInstance.cleanTransportIp + "/in_factory/list";
      let res = await this.globalInstance.$apiUtils.get3(url, this.params);
      // let res = {
      //   firstResult: 0,
      //   list: [
      //     {
      //       createTime: null,
      //       drivingLicense: null,
      //       engineNumber: "20A00366566",
      //       numberPlate: "1#重型半挂牵引车",
      //       onBoardList: null,
      //       registrationDate: "20210527",
      //       vehicleEmissions: 5,
      //       vin: "LZFH25W43LD048493",
      //     },
      //   ],
      //   offsetSize: 3,
      //   pageCount: 1,
      //   pageNo: 1,
      //   pageSize: 10,
      //   rowCount: 8,
      // };
      this.dataList = res.list;
      this.page_total = res.rowCount;
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getCarListInFactory();
    },
    reset() {
      this.params.pageNo = 1;
      this.params.keyword = "";
      this.params.vehicleEmissions = "";
      this.getCarListInFactory();
    },
    rowClick(row) {
      this.detailShow = false;
      // this.info = row;
      this.getCarDetailInFactory(row.numberPlate);
      if(this.newAccessType) {
        this.title = '厂内运输车辆信息';
      }
    },
    async getCarDetailInFactory(number) {
      let url = this.globalInstance.cleanTransportIp + "/in_factory/detail";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        numberPlate: number,
        customerId:this.customerId
      });
      // let res = {
      //   createTime: null,
      //   drivingLicense:
      //     "http://ulev.fj-sanbao.com/prod-api/profile/upload/2021/10/08/闽E89517行驶证.png/1af3b5c3385c9b5f911db1a86e89750c.png",
      //   engineNumber: "20A00366566",
      //   numberPlate: "1#重型半挂牵引车",
      //   onBoardList:
      //     "http://ulev.fj-sanbao.com/prod-api/profile/upload/2021/10/08/闽E89517机动车环保信息随车清单.png/16b081df3ee004fe67b6b5e67cff7657.png",
      //   registrationDate: "20210527",
      //   vehicleEmissions: 5,
      //   vin: "LZFH25W43LD048493",
      // };
      this.info = res;
    },
    returnClick() {
      this.detailShow = true;
      if (this.newAccessType){
        this.title = '厂内运输车辆电子台账';
      } else {
        this.title = '场内运输车辆电子台账';
      }
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
    picture_click(url) {
      if (!url) return;
      this.globalInstance.$store.commit("dialogStatus2", true);
      this.globalInstance.$popup.open2(imgBox, this.dialogCompontent2, this, {
        imgurl: url,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-title {
  text-align: center;
  font-size: 25px;
}
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
  .door-title {
    margin-left: -25px;
    font-size: 24px;
  }
  .basic-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .basic-item {
      width: 33.3%;
      height: 60px;
      line-height: 60px;
      color: white;
      .item-label {
        color: #a2d8ff;
      }
    }
  }
  .picture-info {
    margin-top: 100px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .picture-inner {
      width: 49%;
      margin-bottom: 25px;
      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }
      .picture {
        padding: 10px 100px;
        width: 100%;
        height: 340px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // background-image: url("../img/img_bg.png");
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          font-weight: bold;
          color: #D7D7D7;
          font-size: 24px;
        }
        img {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: "";
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          // background-image: url("./../img/enlarge.png");
        }
      }
    }
  }
}
.page_box {
  margin-top: 20px;
  :deep(.el-pagination) {
      --el-pagination-font-size: 24px;
    }
  :deep(.el-icon-arrow-left) {
    margin: 0 auto;
  }
  :deep(.el-icon-arrow-right) {
    margin: 0 auto;
  }
}
</style>
